import { Black, Blue, GrayDark, GrayLight, colorToRgba, White } from './colors';
import { stylesheet } from 'typestyle';
export const borderPx = 2;
export var CheckboxStyleTypes;
(function (CheckboxStyleTypes) {
    CheckboxStyleTypes["SelectedA"] = "selectedA";
    CheckboxStyleTypes["UnselectedA"] = "unselectedA";
    CheckboxStyleTypes["UnselectedB"] = "unselectedB";
    CheckboxStyleTypes["DisabledSelectedA"] = "disabledSelectedA";
    CheckboxStyleTypes["DisabledUnselected"] = "disabledUnselected";
    CheckboxStyleTypes["Default"] = "default";
})(CheckboxStyleTypes || (CheckboxStyleTypes = {}));
export const checkboxesStyle = stylesheet({
    unselectedA: {
        background: 'transparent',
        boxShadow: `inset 0px 0px 0px ${borderPx}px ${Black}`,
    },
    unselectedB: {
        background: colorToRgba(GrayDark, 0.6) /* Grey Dark 60 */,
        boxShadow: `inset 0px 0px 0px ${borderPx}px ${White}`,
    },
    selectedA: {
        background: Blue,
        color: White,
        boxShadow: 'none',
    },
    disabledSelectedA: {
        background: GrayLight,
        color: GrayDark,
    },
    disabledUnselected: {
        background: GrayDark,
        boxShadow: `inset 0px 0px 0px ${borderPx}px ${GrayLight}`,
    },
    default: {
        background: 'initial',
        color: 'initial',
    },
});
//# sourceMappingURL=checkbox.js.map